import { computed, makeObservable } from 'mobx';
import CalendarEvent from './CalendarEvent';

class CelebrationEvent extends CalendarEvent {
  constructor(other) {
    super();

    makeObservable(this, {
      backgroundColor: computed,
      textColor: computed,
      borderColor: computed
    });
    this.merge(other);
  }

  get backgroundColor() {
    return '#9159B5';
  }

  get textColor() {
    return '#FFFFFF';
  }

  get borderColor() {
    return '#9159B5';
  }
}

export default CelebrationEvent;
